import qs from 'qs'
import { BRAND_COMPATIBILITY_QUERY_NAME } from 'constant'
import { getPageLocation } from 'selectors'

export const getCompatibilityFilterValue = state => {
  const { search } = getPageLocation(state)

  return qs.parse(search.slice(1))[BRAND_COMPATIBILITY_QUERY_NAME]
}
